import {ru, enUS} from 'date-fns/locale';

export interface DateLocalesOptions {
  width: 'abbreviated'
}

const ruNoDot = {
  ...ru,
  localize: {
    ...ru.localize,
    month: (monthIndex: number, options: DateLocalesOptions) => {
      const months = [
        'Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня',
        'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря',
      ];
      // const abbr = [
      //   'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
      //   'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'
      // ];
      const abbr = [
        'янв.', 'фев.', 'мар.', 'апр.', 'май.', 'июн.',
        'июл.', 'авг.', 'сен.', 'окт.', 'ноя.', 'дек.',
      ];

      if (options?.width === 'abbreviated') {
        return abbr[monthIndex];
      }

      return months[monthIndex];
    },
  },
};

export const locales = {
  en: enUS,
  ru: ru,
};
